import videoDesktop from '../../../assets/video/440-MUSIC-DISTRO_WEBSITE-LOOP_021225_15_NO-LOGO_16x9.mp4';
import videoMobile from '../../../assets/video/440-MUSIC-DISTRO_WEBSITE-LOOP_021225_15_NO-LOGO_1x1.mp4';
import { useHeroContent } from '../../../context/ContentContext';
import './Hero.css';
import { useEffect, useState } from "react";
import spotifyLogo from '../../../assets/images/logo_spotify.svg';
import tiktokLogo from '../../../assets/images/logo_tiktok.svg';
import appleMusicLogo from '../../../assets/images/Apple_Music_logo 1.svg';
import youtubeLogo from '../../../assets/images/logo_youtube.svg';
import amazonMusicLogo from '../../../assets/images/Amazon-music.png';
import audiomackLogo from '../../../assets/images/Audiomack.png';
import tidalLogo from '../../../assets/images/Tidal.png';
import iheartLogo from '../../../assets/images/iHeart-Radio.png';
import Marquee from "react-fast-marquee";
import Button from '../../common/Button/Button';
import RightArrow from '../../../assets/images/right-arrow.svg';

export default function Hero() {
    function useIsMobile() {
        const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
        useEffect(() => {
            const handleResize = () => setIsMobile(window.innerWidth < 768);
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);

        return isMobile;
    }
    const isMobile = useIsMobile();

    const { headline, subtext , cta} = useHeroContent();

    const dspLogos = [
        spotifyLogo,
        tiktokLogo,
        appleMusicLogo,
        youtubeLogo,
        amazonMusicLogo,
        audiomackLogo,
        tidalLogo,
        iheartLogo
    ];

    return (
        <>
            <section className="hero" aria-label="Hero section" id="hero">
                {/* Video Background */}
                <div className="hero__video-wrapper">
                    <video
                        className="hero__video hero__video--desktop"
                        src={videoDesktop}
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload="auto"
                    />
                    <video
                        className="hero__video hero__video--mobile"
                        src={videoMobile}
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload="auto"
                    />
                    <div className="hero__overlay" />
                </div>

                <div className="hero__content-container">
                    <div className="hero__content">
                        <h1 className="hero__headline">
                            {headline.line1}<br />
                            {headline.line2}{isMobile ? "" : <br />}
                            {headline.line3prefix}<span className="hero__headline-highlight">{headline.highlight}</span>
                        </h1>

                        <p className="hero__subtext">
                            {subtext}
                        </p>

                        <Button href={cta.href} target="_top" icon={RightArrow} className='hero__cta'>
                            {cta.label}
                        </Button>
                    </div>
                </div>
            </section>
            <div className="marquee">
                <Marquee gradient={false} speed={50} pauseOnHover={true} autoFill={true}>
                    {dspLogos.map((logo, index) => (
                        <img key={`logo-${index}`} src={logo} alt="DSP Logo" className="dsp-logo" />
                    ))}
                </Marquee>
            </div>
        </>
    );
}
